import api from '../../api';

export const SET_PRICES = 'SET_PRICES';

export const setPrices = (prices) => ({
	type: SET_PRICES,
	payload: prices,
});

export function getPricesAction() {
	return async function getProfile(dispatch, getState) {
		if (getState()?.prices?.loaded === false) {
			try {
				const prices = await api.getPrices();
				dispatch(setPrices(prices));
			} catch (error) {
				console.error(error);
			}
		}
	};
}
